export default {
  workstation: {
    tabs: {
      workstation: "Workstation",
    },
    filters: {
      withAll: "Con todos",
      withoutAny: "Sin ninguno",
      withPlayer: "Con {{player}}",
      withoutPlayer: "Sin {{player}}",
      all: "Todos",
      versusPosition: "vs {{position}}",
      starter: "Titular",
      nonStarter: "No titular",
      starterAndNonStarter: "Titular + no titular",
      betType: "Tipo de apuesta",
      timeframe: "Periodo",
      splits: "Divisiones",
      with: "Con",
      without: "Sin",
      opponent: "Rival",
    },
    actions: {
      applyFilter: "Aplicar filtro",
      applied: "Aplicado",
    },
    banners: {
      notPlayingToday: "{{entity}} no juega hoy",
    },
    sections: {
      stats: "Estadísticas",
      seasonStats: "Estadísticas de la temporada",
      last3Seasons: "Últimas 3 temporadas",
      batterVsPitcherGamelog: "Ver registro bateador vs. lanzador",
    },
    stats: {
      perGame: "Por partido",
      total: "Total",
      timeframe: "Periodo",
      filters: "Filtros",
      season: "Temporada",
    },
    headers: {
      type: "Tipo",
      hitRate: "Tasa de acierto",
      odds: "Cuotas",
      stat: "Estadística",
      average: "Promedio",
    },
    outcomes: {
      covered: "Cubrió",
      yes: "Sí",
      no: "No",
      win: "G",
      loss: "P",
      tie: "EMP",
    },
    alerts: {
      imageSavedToDevice: "Imagen guardada en el dispositivo",
    },
  },
};
